export default __webpack_public_path__ + "static/media/7SV512.405a697e.jpg";